import React from 'react';
import {useSelector} from "react-redux";

export default function useCheckModule() {
    const modules = useSelector(state => state.modules);

    return module => modules.includes(module);
}